import { Col } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import { $activeTab } from '../_state/conversation.state';

import { ConversationHeader } from './ConversationHeader';
import { TabFiles } from './TabFiles';
import { TabMessages } from './TabMessages';
import { TabObjects } from './TabObjects';
import { TabParticipants } from './TabParticipants';

export const ConversationCurrent = () => {
  const activeTab = useAtomValue($activeTab);

  return (
    <Col gap2 className="@ConversationCurrent size-full bg-white">
      {/* 🟠🟠🟠 Chat Header */}
      <ConversationHeader />

      {/* 🟠🟠🟠 Active Tab Content */}
      <div className="flex-1 overflow-hidden">
        {/*
          To prevent re-rendering of the chatbox when the tab changes,
          we simply hide it and show it again when the current tab is messages.
        */}
        <TabMessages visible={activeTab === 'messages'} />

        {/* It should be fine to re-render the other tabs when the get focused */}
        {activeTab === 'files' && /* -------- */ <TabFiles />}
        {activeTab === 'participants' && /* - */ <TabParticipants />}
        {activeTab === 'objects' && /* ------ */ <TabObjects />}
      </div>
    </Col>
  );
};
